import type { ProductListType } from "src/types/product-listing";

export const PRODUCT_LIST_CONTEXT_KEYS: Record<
  ProductListType,
  `${
    | Lowercase<Exclude<ProductListType, "SEARCH_PLP" | "COLLECTIONS_PLP">>
    | "collection_plp"
    | "search_catalog_plp"}`
> = {
  BRAND_PLP: "brand_plp",
  CATEGORY_PLP: "category_plp",
  NEW_IN_PLP: "new_in_plp",
  COLLECTIONS_PLP: "collection_plp",
  SEARCH_PLP: "search_catalog_plp",
  DESIGNER_PLP: "designer_plp",
  HOT_DEALS_PLP: "hot_deals_plp",
  SALE_PLP: "sale_plp",
  SHOP_TYPE_PLP: "shop_type_plp",
} as const;

export const PRODUCT_LISTING_TYPE: Record<ProductListType, string> = {
  BRAND_PLP: "brand",
  CATEGORY_PLP: "category",
  COLLECTIONS_PLP: "collection",
  SEARCH_PLP: "search",
  NEW_IN_PLP: "new_in",
  HOT_DEALS_PLP: "hot_deals",
  SALE_PLP: "sale",
  DESIGNER_PLP: "designer",
  SHOP_TYPE_PLP: "shop_type",
} as const;

export type ContextKey =
  (typeof PRODUCT_LIST_CONTEXT_KEYS)[keyof typeof PRODUCT_LIST_CONTEXT_KEYS];
